function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#wait_svg__clip0_75_5055)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 1v2.4m0 7.2V13m6-6h-2.4M3.4 7H1m1.757-4.243l1.697 1.697m5.092 5.092l1.697 1.697m0-8.486L9.546 4.454M4.454 9.546l-1.696 1.696",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "wait_svg__clip0_75_5055"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})));

var SvgWait = function SvgWait(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgWait;